type DrawerSlotProps = {
  marginTop?: number;
  className?: string;
  ref: (ref: HTMLDivElement | null) => void;
};

export const DrawerSlot = ({ className, marginTop = 0, ref }: DrawerSlotProps) => (
  <div
    className={className}
    ref={ref}
    style={{ height: `calc(100vh - ${marginTop}px)`, marginTop: `${marginTop}px` }}
  />
);

DrawerSlot.displayName = 'Drawer';
